import { NotificationContent, NotificationKey } from './notification-native.state';

export class NativeNotificationAddTemplate {
   public static readonly type = '[NativeNotification] Add creation template';

   constructor(public key: string | NotificationKey, public notificationContent: NotificationContent) {}
}
export class NativeNotificationRemoveTemplate {
   public static readonly type = '[NativeNotification] Remove creation template';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}

export class NativeNotificationSetOpenNotifications {
   public static readonly type = '[NativeNotification] Set Open Notifications';

   constructor(public notifications: Notification[]) {}
}

export class NativeNotificationCloseByKey {
   public static readonly type = '[NativeNotification] Close Notification by Tag';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}

export class NativeNotificationFinishClose {
   public static readonly type = '[NativeNotification] Notification is Closed by Tag';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}

export class NativeNotificationAddRequestToOpen {
   public static readonly type = '[NativeNotification] Add request to open Notification';

   constructor(public key: string | NotificationKey) {}
}

export class NativeNotificationAddRequestToClose {
   public static readonly type = '[NativeNotification] Add request to close Notification';

   constructor(public key: string | NotificationKey) {}
}

export class NativeNotificationRemoveRequestToOpen {
   public static readonly type = '[NativeNotification] Remove request to open Notification';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}

export class NativeNotificationRemoveRequestToClose {
   public static readonly type = '[NativeNotification] Remove request to close Notification';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}

export class NativeNotificationSetHighestFiredNativeKeys {
   public static readonly type = '[NativeNotification] set highest notification keys';

   constructor(public keys: NotificationKey | NotificationKey[]) {}
}
